import { routes } from '~constants/routes';

import CharacterIcon from '../../../public/assets/icons/navigation/character.svg';
import ChatsIcon from '../../../public/assets/icons/navigation/chats.svg';
import ExploreIcon from '../../../public/assets/icons/navigation/explore.svg';
import ImagesIcon from '../../../public/assets/icons/navigation/images.svg';

export const navigationPaths = [
	{
		path: routes.explore.home,
		icon: <ExploreIcon />,
		text: 'Explore',
		shortText: 'Explore',
		isDemo: true,
		isSafe: true,
		isDemoSafe: true,
	},
	{
		path: routes.chats.home,
		icon: <ChatsIcon />,
		text: 'Chats',
		shortText: 'Chats',
		isDemo: true,
		isSafe: true,
		isDemoSafe: true,
	},
	{
		path: routes.generate.character,
		icon: <CharacterIcon />,
		text: 'Create Character',
		shortText: `+ Character`,
		isDemo: true,
		isSafe: false,
		isDemoSafe: false, // show auth modal but demo user still can create character
	},
	{
		path: routes.generate.images,
		icon: <ImagesIcon />,
		text: 'Create Media',
		shortText: '+ Media',
		isDemo: true,
		isSafe: false,
		isDemoSafe: true,
	},
];
